import { EhrName } from "@metriport/shared-internal";
import { PatientMapping } from "../../../api/ehr";
import EhrLinkSection from "../shared/PatientLinking";

type ElationSectionProps = {
  patientMapping: PatientMapping | undefined;
  cxId: string;
};

export default function ElationSection({ patientMapping, cxId }: ElationSectionProps) {
  return <EhrLinkSection ehr={EhrName.Elation} patientMapping={patientMapping} cxId={cxId} />;
}
